// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3rNcq","resendInfoText":"OnGoingPaymentBox_resendInfoText__2kfZN"};